import consumer from "./consumer"

consumer.subscriptions.create("SuperadminChannel", {
  connected(e) {
    // Called when the subscription is ready for use on the server
    // console.log('SuperadminChannel connected', e);
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
    // console.log('SuperadminChannel disconnected');
  },

  received(data) {
    // Called when there's incoming data on the websocket for this channel
    App.emit(data.event_name, data.payload);
  }
});
